<template>
  <div>
    <!-- 联合创始人 -->
    <SRF>
      <BoosBanner :leaderList="leaderList" />
    </SRF>
    <!-- 我们的团队 -->
    <SRF>
      <OurTeam />
    </SRF>
    <!-- 人物 -->
    <SRF>
      <PersonSwiper :teamList="teamList" />
    </SRF>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import utils from "@/api/Utils";
import BoosBanner from "./components/BoosBanner";
import OurTeam from "./components/OurTeam";
import PersonSwiper from "./components/PersonSwiper";
import Footer from "@/components/MobileIframe/components/Footer";
import { pageApi } from "@/api";

export default {
  components: {
    BoosBanner,
    OurTeam,
    PersonSwiper,
    Footer,
  },
  data() {
    return {
      teamList: [],
      leaderList: [],
    };
  },
  mounted() {
    // console.log(this.$ismobile)//是否为移动端
    // if (!this.$ismobile) {
    //   this.$router.push({
    //     path: "/"
    //   });
    // } else {
    // }
    this.getData();
  },
  methods: {
    async getData() {
      const res = await pageApi.getTeamList();
      const data = res.result;
      this.teamList = data.tuan_arr;
      this.leaderList = data.leader_arr;
    },
  },
};
</script>

<style scoped>
/* 页面基础样式 */
.mobile-page-team {
  width: 100%;
  height: 100%;
  background: #0d0d0d;
}
</style>
